import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary, {
  ErrorBoundaryProps,
} from 'client/shared/decorators/error-boundary'
import urlFor, { QueryParams } from 'shared/tools/url-helper'
import deviceHelper from 'shared/tools/device-helper'
import navHelper from 'client/bookmate/helpers/nav-helper'
import { buildUser } from 'client/bookmate/reducers/user-reducer'

import StoreButtonBox from 'client/shared/boxes/store-button-box'
import FollowButtonBox from 'client/bookmate/boxes/follow-button-box'

import { SubHeader } from 'client/bookmate/blocks/sub-header'
import { UserAvatar } from 'client/shared/blocks/user-avatar'

import { UserCombined } from 'client/shared/types/user'
import { State as AppState } from 'client/shared/reducers/app-reducer'
import { Dispatch, State } from 'shared/types/redux'

type Props = {
  user: UserCombined
  hidden: boolean
  app: AppState
  dispatch: Dispatch
  query?: QueryParams
} & ErrorBoundaryProps

class UserSubHeaderBox extends Component<Props> {
  static defaultProps = {
    hidden: false,
  }

  render(): JSX.Element {
    const {
      app,
      user,
      user: { login, name, myself },
      hidden,
      query,
    } = this.props

    const buttonRenderer = deviceHelper.isMobileOS(app)
      ? this.renderStoreButton
      : this.renderActionButton

    return (
      <SubHeader
        title={name || login}
        nav={navHelper.userNav(user, app.storedQuery)}
        previewLink={urlFor.user(login, query)}
        renderCover={this.renderCover}
        renderButton={buttonRenderer}
        kind={myself ? 'user' : 'default'}
        hidden={hidden}
        query={query}
      />
    )
  }

  renderCover = () => {
    const { user } = this.props

    return <UserAvatar user={user} />
  }

  renderStoreButton = () => {
    return <StoreButtonBox inverted size="small" />
  }

  renderActionButton = () => {
    const {
      user,
      user: { following, myself },
    } = this.props

    if (myself) return null

    return <FollowButtonBox user={user} following={following} width="160px" />
  }
}

const connectWrapper = connect((state: State) => ({
  app: state.app,
  user: buildUser(state, state.user.login),
  query: state.app.storedQuery,
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(UserSubHeaderBox)
